import React, { useEffect, useState } from 'react';
import { confirmEmail } from '../services/auth.service';
import LoadingSpinner from '../components/LoadingSpinner';
import { Link } from 'react-router-dom';
import { getUrlParams } from '../services/parameter.service';

const ConfirmEmail: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [successful, setIsSuccessful] = useState(false);

  const { userId, code } = getUrlParams();

  const confirm = async () => {
    const result = await confirmEmail(userId, code);
    if (result.success) {
      setIsSuccessful(true);
    }
    setLoading(false);
  };

  useEffect(() => {
    confirm();
  }, []);

  return (
    <div>
      {loading && <LoadingSpinner />}
      {!loading && successful && (
        <div>
          Email address confirmed. Please{' '}
          <Link to="/Account/Login">log in</Link>.
        </div>
      )}
      {!loading && !successful && <div>Invalid link, please try again.</div>}
    </div>
  );
};

export default ConfirmEmail;
